export default __webpack_public_path__ + "static/media/classroom 1.c809c961.jpg";